// extracted by mini-css-extract-plugin
module.exports = {"Console":"Console__Console__23ZLn","VolumeControl":"Console__VolumeControl__1g5Rg"};